<template>
    <section>
        滑动控件
        <mu-slider />
    </section>
</template>
<script>
	export default{
		name:'slider'
	}
</script>


// WEBPACK FOOTER //
// slider.vue?ba797614